<button mat-menu-item [disabled]="tileSize === 1" (click)="tileSizeChanged.emit(1)">
  <mat-icon class="small-tiles">check_box_outline_blank</mat-icon>
  <span>{{ 'button.small_tile_size' | translate }}</span>
</button>
<button mat-menu-item [disabled]="tileSize === 1.5" (click)="tileSizeChanged.emit(1.5)">
  <mat-icon class="medium-tiles">check_box_outline_blank</mat-icon>
  <span>{{ 'button.medium_tile_size' | translate }}</span>
</button>
<button mat-menu-item [disabled]="tileSize === 2" (click)="tileSizeChanged.emit(2)">
  <mat-icon class="large-tiles">check_box_outline_blank</mat-icon>
  <span>{{ 'button.large_tile_size' | translate }}</span>
</button>

<mat-divider></mat-divider>

<button mat-menu-item (click)="roiBoxVisibleChanged.emit(!roiBoxVisible)">
  <mat-icon>{{ roiBoxVisible ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
  <span>{{ 'button.roi_boxes' | translate }}</span>
</button>
